import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material';

export const ModernAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  boxShadow: 'none',
  marginBottom: theme.spacing(2),
  '&:before': { display: 'none' },
  '&.Mui-expanded': { margin: 0, marginBottom: theme.spacing(2) },
}));

export const ModernAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  minHeight: 44,
  '&.Mui-expanded': { minHeight: 44, borderBottom: `1px solid ${theme.palette.divider}` },
  '& .MuiAccordionSummary-content': { margin: '8px 0' },
  '& .MuiTypography-root': {
    fontSize: '0.8125rem',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: theme.palette.text.primary,
  },
}));

export const ModernAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
}));
